import type { SxProps, Theme } from "@mui/material";

import { darkModeTextLinkSx, isDarkMode } from "@/src/theme/helpers";
import { schemeSx } from "@/src/theme/schemeStyles";
import { homePageHeroColors } from "@/src/theme/tokens";

import { HOMEPAGE_FRONT_PAGE_CONTAINER_STYLES } from "@/src/pages/consumer/HomePage/homePage.constants";

// The outer box carries the shared section padding, so the card's edges line
// up with the content of the other sections.
export const homePageFAQListOuterSx: SxProps<Theme> = {
  ...HOMEPAGE_FRONT_PAGE_CONTAINER_STYLES,
  px: { xs: 1, sm: 3, lg: 5 }
};

const homePageFAQListDarkTextSx = schemeSx((muiTheme: Theme) => ({
  color: muiTheme.palette.text.primary,
  ".MuiTypography-root": {
    color: muiTheme.palette.text.primary
  },
  ".MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root": {
    color: muiTheme.palette.text.primary
  }
}));

export const homePageFAQListAccordionDetailsTextSx: SxProps<Theme> = schemeSx(
  (muiTheme) =>
    isDarkMode(muiTheme)
      ? {
          color: muiTheme.palette.text.primary,
          ">a": darkModeTextLinkSx(muiTheme)
        }
      : {}
);

export const homePageFAQListSectionSx: SxProps<Theme> = schemeSx(
  (muiTheme) => ({
    borderRadius: "2rem",
    py: 4,
    px: [3, 4],
    background: muiTheme.palette.misc.timelineBackground,
    ul: {
      pl: 0
    },
    ".MuiAccordion-root, .MuiAccordionSummary-root, .MuiAccordionDetails-root":
      {
        backgroundColor: muiTheme.palette.misc.timelineBackground
      },
    ".MuiAccordionSummary-root:hover, .MuiAccordionSummary-root.Mui-expanded": {
      backgroundColor: muiTheme.palette.misc.timelineBackground
    },
    ...(isDarkMode(muiTheme)
      ? {
          border: "1px solid",
          borderColor: homePageHeroColors.cardDarkBorder,
          boxShadow: "none",
          ...homePageFAQListDarkTextSx(muiTheme),
          ul: {
            pl: 0,
            ".MuiAccordionSummary-root": {
              borderTopColor: homePageHeroColors.cardDarkBorder
            }
          }
        }
      : {
          boxShadow: muiTheme.shadows[4]
        })
  })
);

export const homePageFAQReadMoreButtonSx: SxProps<Theme> = schemeSx(
  (muiTheme) =>
    isDarkMode(muiTheme) ? { color: muiTheme.palette.text.primary } : {}
);
